import React from 'react';
import Layout from '../../components/Layout';
import ContentWithStickySidebar from '../../components/shared/ContentWithStickySidebar';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import IntroSection from './IntroSection';
import SecuritySection from './SecuritySection';
import FAQSection from './FAQSection';
import HeroImage from '../../images/TrustLPHeader.webp';

const TrustCenter = () => (
  <Layout title="Trust Center">
    <HeroWithBackgroundImage
      imageUrl={HeroImage}
      backgroundColor="'rgba(255,255,255,.55)'"
      title="Trust Center"
    />
    <ContentWithStickySidebar>
      <IntroSection />
      <SecuritySection />
      <FAQSection />
    </ContentWithStickySidebar>
  </Layout>
);

export default TrustCenter;
